// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-form-layout.abstract-form {
  padding-block: 10px 0;
}
.users-form-layout .container1 {
  display: flex;
  align-items: stretch;
  gap: 20px;
}
.users-form-layout .users-form-main {
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 28px 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.users-form-layout .users-form-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 16px;
  border-bottom: 1px solid #e8eef4;
  margin-bottom: 4px;
}
.users-form-layout .users-form-card-header h3 {
  margin: 0;
  color: #172033;
  font-size: 18px;
}
.users-form-layout .users-form-card-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.users-form-layout .users-form-card-header__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 8px;
}
.users-form-layout .users-form-card-header__meta-label {
  color: #004195;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}
.users-form-layout .users-form-card-header__meta-value {
  color: #172033;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}
.users-form-layout .users-form-card-header .ant-btn {
  padding-inline: 8px;
}
.users-form-layout .users-form-card-header .invert-fill-btn {
  font-size: 14px;
  padding: 8px 16px;
  height: 36px;
}
.users-form-layout .users-form-card-header .invert-fill-btn .button-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.users-form-layout .users-form-readonly {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 24px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.users-form-layout .users-form-readonly__item {
  min-width: 0;
  padding: 16px 0;
}
.users-form-layout .users-form-readonly__item--row-start {
  grid-column-start: 1;
}
.users-form-layout .users-form-readonly__item--section-divider {
  position: relative;
  grid-column: 1;
  padding-top: 24px;
}
.users-form-layout .users-form-readonly__item--section-divider::before {
  content: "Payment Details";
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-50%);
  background: #fff;
  color: #004195;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-align: left;
  padding-right: 8px;
  z-index: 1;
}
.users-form-layout .users-form-readonly__item--section-divider::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(300% + 48px);
  border-top: 1px solid #e2e8f0;
  z-index: 0;
}
.users-form-layout .users-form-readonly__item--section-divider + .users-form-readonly__item {
  padding-top: 24px;
}
.users-form-layout .users-form-readonly__label-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.users-form-layout .users-form-readonly__icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #eff6ff;
}
.users-form-layout .users-form-readonly__icon {
  color: #075dc5;
}
.users-form-layout .users-form-readonly__label {
  display: block;
  color: #004195;
  font-size: 15px;
  font-weight: 600;
}
.users-form-layout .users-form-readonly__value {
  display: block;
  overflow-wrap: anywhere;
  color: #172033;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  padding-left: 42px;
}
.users-form-layout .users-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 20px;
  padding-top: 20px;
}
.users-form-layout .users-form-grid--full-width {
  grid-column: 1/-1;
}
.users-form-layout .users-form-grid--row-start {
  grid-column-start: 1;
}
.users-form-layout .users-form-grid--section-divider {
  position: relative;
  grid-column: 1;
  padding-top: 28px;
}
.users-form-layout .users-form-grid--section-divider::before {
  content: "Payment Details";
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-50%);
  background: #fff;
  color: #004195;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-align: left;
  padding-right: 8px;
  z-index: 1;
}
.users-form-layout .users-form-grid--section-divider::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(200% + 24px);
  border-top: 1px solid #e2e8f0;
  z-index: 0;
}
.users-form-layout .users-form-grid--section-divider + div {
  padding-top: 28px;
}
.users-form-layout .users-form-grid--hidden {
  display: none;
}
.users-form-layout .users-form-grid .ant-form-item {
  margin-bottom: 0;
}
.users-form-layout .users-form-grid .ant-form-item-label {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  text-align: left !important;
  padding: 0 0 6px !important;
  line-height: 1.4 !important;
}
.users-form-layout .users-form-grid .ant-form-item-label > label {
  height: auto !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #004195 !important;
}
.users-form-layout .users-form-grid .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  color: #dc2626 !important;
}
.users-form-layout .users-form-grid .ant-col-4,
.users-form-layout .users-form-grid .ant-col-8 {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.users-form-layout .users-form-grid .ant-col-offset-4 {
  margin-left: 0 !important;
}
.users-form-layout .users-form-grid .ant-form-item-control {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.users-form-layout .users-form-grid .ant-input,
.users-form-layout .users-form-grid .ant-input-affix-wrapper,
.users-form-layout .users-form-grid .ant-select-selector {
  border-radius: 6px !important;
  border-color: #e2e8f0 !important;
  min-height: 42px !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  box-shadow: none !important;
}
.users-form-layout .users-form-grid .ant-input-affix-wrapper {
  padding: 0 12px !important;
}
.users-form-layout .users-form-grid .ant-input-affix-wrapper .ant-input {
  min-height: 38px !important;
  padding: 0 !important;
  border: none !important;
}
.users-form-layout .users-form-grid .ant-select-single .ant-select-selector {
  display: flex;
  align-items: center;
}
.users-form-layout .users-form-grid .ant-select-selection-placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
}
.users-form-layout .users-form-grid .ant-select-arrow {
  color: #64748b !important;
}
.users-form-layout .users-form-grid .ant-select-multiple {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 42px !important;
  max-height: none !important;
  overflow: visible !important;
  padding: 4px 10px !important;
}
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-selection-overflow {
  flex-wrap: wrap !important;
  row-gap: 4px;
}
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-selection-item,
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-selection-placeholder {
  max-width: none !important;
}
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-clear,
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-selection-item-remove {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  color: #60758d;
  opacity: 1;
}
.users-form-layout .users-form-grid .ant-select-multiple .ant-select-clear {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 2;
}
.users-form-layout .users-form-grid .ant-input:hover,
.users-form-layout .users-form-grid .ant-input:focus,
.users-form-layout .users-form-grid .ant-input-affix-wrapper:hover,
.users-form-layout .users-form-grid .ant-input-affix-wrapper-focused,
.users-form-layout .users-form-grid .ant-select-selector:hover,
.users-form-layout .users-form-grid .ant-select-focused .ant-select-selector {
  border-color: #004195 !important;
  box-shadow: none !important;
}
.users-form-layout .users-form-grid .leftOffset::after {
  content: none;
}
.users-form-layout .users-form-grid .inline-field-group {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.users-form-layout .users-form-grid .inline-field-group__country, .users-form-layout .users-form-grid .inline-field-group__phone {
  min-width: 0;
}
.users-form-layout .users-form-main .users-form-actions {
  margin-top: 28px;
  padding-top: 4px;
}
.users-form-layout .btn-container {
  margin: 24px 0 0 0;
  padding-top: 4px;
}
.users-form-layout .query-form-hidden-fields {
  display: none;
}
.users-form-layout .users-form-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.users-form-layout .users-form-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 40px;
  padding: 0 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
  border: 2px solid transparent;
}
.users-form-layout .users-form-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: scale(0.98);
}
.users-form-layout .users-form-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.users-form-layout .users-form-btn--update {
  background: #004195;
  color: #fff;
  border-color: #004195;
}
.users-form-layout .users-form-btn--delete {
  background: #dc2626;
  color: #fff;
  border-color: #dc2626;
}
.users-form-layout .users-form-btn--cancel {
  background: #fff;
  color: #004195;
  border-color: #004195;
}
.users-form-layout .users-form-btn--create {
  background: #004195;
  color: #fff;
  border-color: #004195;
}

@media (max-width: 1024px) {
  .users-form-layout .container1 {
    flex-direction: column;
  }
  .users-form-layout .users-form-grid {
    grid-template-columns: 1fr;
  }
  .users-form-layout .users-form-grid--section-divider::after {
    width: 100%;
  }
  .users-form-layout .users-form-readonly {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .users-form-layout .inline-field-group {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .users-form-layout .inline-field-group__country, .users-form-layout .inline-field-group__phone {
    flex: 1 1 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Entity/AbstractForm/userForm.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAGE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;AADJ;AAIE;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AAHJ;AAKI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAJN;AAOI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AALN;AAQI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AANN;AASI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AAUI;EACE,mBAAA;AARN;AAWI;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AATN;AAWM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AATR;AAcE;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,YAAA;EACA,eAAA;AAZN;AAcM;EACE,oBAAA;AAZR;AAeM;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AAbR;AAeQ;EACE,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAbV;AAgBQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AAdV;AAmBI;EACE,iBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAlBN;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAnBN;AAsBI;EACE,cAAA;AApBN;AAuBI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArBN;AAwBI;EACE,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAtBN;AA0BE;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAxBJ;AA0BI;EACE,iBAAA;AAxBN;AA2BI;EACE,oBAAA;AAzBN;AA4BI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AA1BN;AA4BM;EACE,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AA1BR;AA6BM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AA3BR;AA+BI;EACE,iBAAA;AA7BN;AAgCI;EACE,aAAA;AA9BN;AAiCI;EACE,gBAAA;AA/BN;AAkCI;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AAhCN;AAkCM;EACE,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;AAhCR;AAkCQ;EACE,yBAAA;AAhCV;AAqCI;;EAEE,yBAAA;EACA,0BAAA;AAnCN;AAsCI;EACE,yBAAA;AApCN;AAuCI;EACE,yBAAA;EACA,0BAAA;AArCN;AAwCI;;;EAGE,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AAtCN;AAyCI;EACE,0BAAA;AAvCN;AAyCM;EACE,2BAAA;EACA,qBAAA;EACA,uBAAA;AAvCR;AA2CI;EACE,aAAA;EACA,mBAAA;AAzCN;AA4CI;EACE,yBAAA;EACA,2BAAA;AA1CN;AA6CI;EACE,yBAAA;AA3CN;AAgDI;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;AA9CN;AAgDM;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;AA9CR;AAiDM;EACE,0BAAA;EACA,YAAA;AA/CR;AAkDM;;EAEE,0BAAA;AAhDR;AAmDM;;EAEE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;AAjDR;AAoDM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAlDR;AAsDI;;;;;;EAME,gCAAA;EACA,2BAAA;AApDN;AAuDI;EACE,aAAA;AArDN;AAwDI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAtDN;AAwDM;EAEE,YAAA;AAvDR;AA6DI;EACE,gBAAA;EACA,gBAAA;AA3DN;AA+DE;EACE,kBAAA;EACA,gBAAA;AA7DJ;AAgEE;EACE,aAAA;AA9DJ;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA/DJ;AAkEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yCACE;EAEF,6BAAA;AAlEJ;AAoEI;EACE,aAAA;EACA,sBAAA;AAlEN;AAqEI;EACE,YAAA;EACA,mBAAA;AAnEN;AAsEI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AApEN;AAuEI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AArEN;AAwEI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAtEN;AAyEI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAvEN;;AA4EA;EAEI;IACE,sBAAA;EA1EJ;EA6EE;IACE,0BAAA;EA3EJ;EA6EI;IACE,WAAA;EA3EN;EA+EE;IACE,gDAAA;EA7EJ;EAgFE;IACE,iCAAA;IACA,oBAAA;EA9EJ;EAgFI;IAEE,yBAAA;EA/EN;AACF","sourcesContent":[".users-form-layout {\n  &.abstract-form {\n    padding-block: 10px 0;\n  }\n\n  .container1 {\n    display: flex;\n    align-items: stretch;\n    gap: 20px;\n  }\n\n  .users-form-main {\n    flex: 1;\n    min-width: 0;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 28px 32px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  }\n\n  .users-form-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 0 16px;\n    border-bottom: 1px solid #e8eef4;\n    margin-bottom: 4px;\n\n    h3 {\n      margin: 0;\n      color: #172033;\n      font-size: 18px;\n    }\n\n    &__actions {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      flex-wrap: wrap;\n    }\n\n    &__meta {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      margin-right: 8px;\n    }\n\n    &__meta-label {\n      color: #004195;\n      font-size: 12px;\n      font-weight: 600;\n      line-height: 1.2;\n    }\n\n    &__meta-value {\n      color: #172033;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 1.3;\n    }\n\n    .ant-btn {\n      padding-inline: 8px;\n    }\n\n    .invert-fill-btn {\n      font-size: 14px;\n      padding: 8px 16px;\n      height: 36px;\n\n      .button-content {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n  }\n\n  .users-form-readonly {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0 24px;\n    padding-bottom: 8px;\n    padding-top: 8px;\n\n    &__item {\n      min-width: 0;\n      padding: 16px 0;\n\n      &--row-start {\n        grid-column-start: 1;\n      }\n\n      &--section-divider {\n        position: relative;\n        grid-column: 1;\n        padding-top: 24px;\n\n        &::before {\n          content: 'Payment Details';\n          position: absolute;\n          top: 0;\n          left: 0;\n          transform: translateY(-50%);\n          background: #fff;\n          color: #004195;\n          font-size: 14px;\n          font-weight: 600;\n          line-height: 1;\n          text-align: left;\n          padding-right: 8px;\n          z-index: 1;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: calc(300% + 48px);\n          border-top: 1px solid #e2e8f0;\n          z-index: 0;\n        }\n      }\n    }\n\n    &__item--section-divider + .users-form-readonly__item {\n      padding-top: 24px;\n    }\n\n    &__label-wrap {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 8px;\n    }\n\n    &__icon-box {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      flex-shrink: 0;\n      border-radius: 6px;\n      background: #eff6ff;\n    }\n\n    &__icon {\n      color: #075dc5;\n    }\n\n    &__label {\n      display: block;\n      color: #004195;\n      font-size: 15px;\n      font-weight: 600;\n    }\n\n    &__value {\n      display: block;\n      overflow-wrap: anywhere;\n      color: #172033;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.5;\n      padding-left: 42px;\n    }\n  }\n\n  .users-form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 24px;\n    row-gap: 20px;\n    padding-top: 20px;\n\n    &--full-width {\n      grid-column: 1 / -1;\n    }\n\n    &--row-start {\n      grid-column-start: 1;\n    }\n\n    &--section-divider {\n      position: relative;\n      grid-column: 1;\n      padding-top: 28px;\n\n      &::before {\n        content: 'Payment Details';\n        position: absolute;\n        top: 0;\n        left: 0;\n        transform: translateY(-50%);\n        background: #fff;\n        color: #004195;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 1;\n        text-align: left;\n        padding-right: 8px;\n        z-index: 1;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: calc(200% + 24px);\n        border-top: 1px solid #e2e8f0;\n        z-index: 0;\n      }\n    }\n\n    &--section-divider + div {\n      padding-top: 28px;\n    }\n\n    &--hidden {\n      display: none;\n    }\n\n    .ant-form-item {\n      margin-bottom: 0;\n    }\n\n    .ant-form-item-label {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n      text-align: left !important;\n      padding: 0 0 6px !important;\n      line-height: 1.4 !important;\n\n      >label {\n        height: auto !important;\n        font-size: 14px !important;\n        font-weight: 600 !important;\n        color: #004195 !important;\n\n        &.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n          color: #dc2626 !important;\n        }\n      }\n    }\n\n    .ant-col-4,\n    .ant-col-8 {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n    }\n\n    .ant-col-offset-4 {\n      margin-left: 0 !important;\n    }\n\n    .ant-form-item-control {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n    }\n\n    .ant-input,\n    .ant-input-affix-wrapper,\n    .ant-select-selector {\n      border-radius: 6px !important;\n      border-color: #e2e8f0 !important;\n      min-height: 42px !important;\n      padding: 8px 12px !important;\n      font-size: 14px !important;\n      box-shadow: none !important;\n    }\n\n    .ant-input-affix-wrapper {\n      padding: 0 12px !important;\n\n      .ant-input {\n        min-height: 38px !important;\n        padding: 0 !important;\n        border: none !important;\n      }\n    }\n\n    .ant-select-single .ant-select-selector {\n      display: flex;\n      align-items: center;\n    }\n\n    .ant-select-selection-placeholder {\n      color: #94a3b8 !important;\n      font-weight: 400 !important;\n    }\n\n    .ant-select-arrow {\n      color: #64748b !important;\n    }\n\n    // Multiple selections wrap and expand the field instead of scrolling,\n    // so the bucket field grows with its content without overlapping below fields.\n    .ant-select-multiple {\n      height: auto !important;\n      max-height: none !important;\n      overflow: visible !important;\n\n      .ant-select-selector {\n        height: auto !important;\n        min-height: 42px !important;\n        max-height: none !important;\n        overflow: visible !important;\n        padding: 4px 10px !important;\n      }\n\n      .ant-select-selection-overflow {\n        flex-wrap: wrap !important;\n        row-gap: 4px;\n      }\n\n      .ant-select-selection-item,\n      .ant-select-selection-placeholder {\n        max-width: none !important;\n      }\n\n      .ant-select-clear,\n      .ant-select-selection-item-remove {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        color: #60758d;\n        opacity: 1;\n      }\n\n      .ant-select-clear {\n        position: absolute;\n        top: 10px;\n        right: 12px;\n        z-index: 2;\n      }\n    }\n\n    .ant-input:hover,\n    .ant-input:focus,\n    .ant-input-affix-wrapper:hover,\n    .ant-input-affix-wrapper-focused,\n    .ant-select-selector:hover,\n    .ant-select-focused .ant-select-selector {\n      border-color: #004195 !important;\n      box-shadow: none !important;\n    }\n\n    .leftOffset::after {\n      content: none;\n    }\n\n    .inline-field-group {\n      display: flex;\n      gap: 12px;\n      align-items: flex-start;\n\n      &__country,\n      &__phone {\n        min-width: 0;\n      }\n    }\n  }\n\n  .users-form-main {\n    .users-form-actions {\n      margin-top: 28px;\n      padding-top: 4px;\n    }\n  }\n\n  .btn-container {\n    margin: 24px 0 0 0;\n    padding-top: 4px;\n  }\n\n  .query-form-hidden-fields {\n    display: none;\n  }\n\n  .users-form-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  .users-form-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 100px;\n    height: 40px;\n    padding: 0 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition:\n      opacity 0.2s,\n      transform 0.15s;\n    border: 2px solid transparent;\n\n    &:hover:not(:disabled) {\n      opacity: 0.92;\n      transform: scale(0.98);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    &--update {\n      background: #004195;\n      color: #fff;\n      border-color: #004195;\n    }\n\n    &--delete {\n      background: #dc2626;\n      color: #fff;\n      border-color: #dc2626;\n    }\n\n    &--cancel {\n      background: #fff;\n      color: #004195;\n      border-color: #004195;\n    }\n\n    &--create {\n      background: #004195;\n      color: #fff;\n      border-color: #004195;\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .users-form-layout {\n    .container1 {\n      flex-direction: column;\n    }\n\n    .users-form-grid {\n      grid-template-columns: 1fr;\n\n      &--section-divider::after {\n        width: 100%;\n      }\n    }\n\n    .users-form-readonly {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .inline-field-group {\n      flex-direction: column !important;\n      gap: 20px !important;\n\n      &__country,\n      &__phone {\n        flex: 1 1 100% !important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
